import React from "react";
import { Grid, Typography, TextField } from "@mui/material";
import CardTitle from "./CardTitle";

function ContactDetails({
	formData,
	setFormData,
	inputErrors,
	checkEmail,
	size,
	borderRadius,
}) {
	return (
		<Grid container spacing={2}>
			<CardTitle title="Contact details">
				<Grid
					item
					xs={12}
					lg={4}
					xl={4}
					sm={12}
					mt={2}
				>
					<Typography variant="h7" component="h4" sx={{ color: "red" }}>
						* please be advised that your contact info will only be shared with daters
						AFTER you have confirmed yourself as taking the role of active shadchan for
						a specific shidduch.
					</Typography>
				</Grid>
			</CardTitle>

			<Grid item xs={12} sm={6}>
				<TextField
					value={formData?.email ?? ""}
					size={size}
					id="email_input"
					type="text"
					autoComplete="email"
					fullWidth
					required
					label="Your email address"
					variant="outlined"
					error={inputErrors?.email}
					helperText={inputErrors?.email}
					onChange={(e) => setFormData({ ...formData, email: e?.target?.value })}
					onBlur={() => checkEmail()}
					InputProps={{ sx: { borderRadius: borderRadius } }}
				/>
			</Grid>

			<Grid item xs={12} sm={6}>
				<TextField
					value={formData?.phone ?? ""}
					size={size}
					id="phone_input"
					type="tel"
					autoComplete="tel"
					fullWidth
					required
					label="Your phone number, (Will also be used to verify your identity)"
					variant="outlined"
					error={inputErrors?.phone}
					helperText={inputErrors?.phone}
					onChange={(e) => setFormData({ ...formData, phone: e?.target?.value })}
					onBlur={() => checkEmail()}
					InputProps={{ sx: { borderRadius: borderRadius } }}
				/>
			</Grid>
		</Grid>
	);
}

export default ContactDetails;
